export const inventoryColumns = [
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    width: 80,
    cellClassName: "actions",
  },
  {
    field: "toCustomer",
    headerName: "To Customer",
    sortable: false,
    align: "left",
    flex: 1.3,
    minWidth: 130,
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    sortable: false,
    align: "left",
    flex: 1.8,
    minWidth: 180,
  },
  {
    field: "quantity",
    headerName: "Quantity",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    headerAlign: 'right',
  },
  {
    field: "quantityAvailable",
    headerName: "Quantity Available",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    headerAlign: 'right',
  },
  {
    field: "transferQuantity",
    headerName: "Transfer Quantity",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    type: 'number',
  },
  {
    field: "baseUOM",
    headerName: "Base UOM",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
];